import React from 'react';
import { getStatusCircleClass } from '../utils/euStatusUtils';
import { getTrendArrow, getTrendArrowClass } from '../utils/euTrendUtils';
import '../utils/sharedStyles.css';
import './GoalAssessmentBadges.css';

/**
 * Goal-tile assessment badges.
 * EU: status (benchmark quintile circle) + progress (trend arrow).
 * UN: progress / trend only (CP-1).
 */
const GoalAssessmentBadges = ({
  goalType,
  statusCategory,
  trendCategory,
  size = 'md',
  variant = 'pill',
  className = '',
}) => {
  const showStatus = goalType !== 'un';
  const status = statusCategory || '';
  const trend = trendCategory || '';
  const { arrow } = getTrendArrow(trend);
  const trendClass = getTrendArrowClass(trend);

  return (
    <div
      className={`goal-assessment-badges goal-assessment-badges--${size} goal-assessment-badges--${variant}${showStatus ? ' has-status' : ''} ${className}`.trim()}
      aria-label={
        showStatus
          ? `Status: ${status || 'unavailable'}. Progress: ${trend || 'unavailable'}`
          : `Progress: ${trend || 'unavailable'}`
      }
    >
      {showStatus ? (
        <div
          className={`status-circle status-circle-${size === 'lg' ? 'medium' : 'small'} ${getStatusCircleClass(status)}`}
          title={status || 'No status / insufficient data'}
        />
      ) : null}
      <span
        className={`trend-arrow trend-arrow-${size === 'lg' ? 'large' : 'small'} ${trendClass}`}
        title={trend || 'Insufficient data'}
      >
        {arrow}
      </span>
    </div>
  );
};

export default GoalAssessmentBadges;
